import React from 'react';
import { CHILD_DEFAULT_AGE, CHILD_MAX_AGE, CHILD_MIN_AGE } from '@common/const/common';
import { DeclinationMnemonic } from '@common/model/resource/declinationMnemonic';
import { SelectItemModel } from '@cp/ds/src/components/select/model';
import { useDeclination } from '@cp/shared/declination';

export const useChildAgeSelectItems = (): SelectItemModel[] => {
  const declination = useDeclination();

  return React.useMemo(() => {
    return Array.from(new Array(CHILD_MAX_AGE - CHILD_MIN_AGE), (_, index) => {
      const age = CHILD_MIN_AGE + index;
      return {
        value: age,
        label: !index ? 'меньше года' : `${age}${age === CHILD_MIN_AGE ? '+' : ''}${declination(age, DeclinationMnemonic.Year)}`,
      };
    });
  }, [declination]);
};

export const CHILD_AGE_DEFAULT = CHILD_DEFAULT_AGE;
